import http from "../../../service/axios";
import { CrossSellRequest } from "../types/CrossSell";

export const crossSellAPI = {
  getProducts: ({ branchId, productIds, signal }: CrossSellRequest) =>
    http.post(
      "/cross-sell",
      { product_ids: productIds },
      {
        params: { branch_id: branchId },
        signal,
        headers: { "Content-Type": "application/json" },
      },
    ),
};
